import { DivergenceStatusEnum } from "@/enum/divergence-status";
import { NsuStatusEnum } from "@/enum/nsu-status";

import { DIVERGENCE_STATUS_LABELS, RESUBMISSION_LABELS } from "./messages";
import { RESUBMISSION_FILTER_VALUE } from "./resubmission";

export interface StatusOption {
  value: string;
  label: string;
}

const RESUBMISSION_STATUS_OPTION: Readonly<StatusOption> = {
  value: RESUBMISSION_FILTER_VALUE,
  label: RESUBMISSION_LABELS.FILTER_OPTION,
};

export const divergenceStatusOptions: StatusOption[] = [
  ...Object.values(DivergenceStatusEnum).map(
    (status: DivergenceStatusEnum): StatusOption => ({
      value: status,
      label: DIVERGENCE_STATUS_LABELS[status],
    })
  ),
  RESUBMISSION_STATUS_OPTION,
];

export const nsuStatusOptions: StatusOption[] = [
  ...Object.values(NsuStatusEnum).map(
    (status: NsuStatusEnum): StatusOption => ({
      value: status,
      label: DIVERGENCE_STATUS_LABELS[status],
    })
  ),
  RESUBMISSION_STATUS_OPTION,
];

const STATUS_LABELS: Readonly<Record<string, string>> = DIVERGENCE_STATUS_LABELS;

export const statusLabelOf = (status: string): string => STATUS_LABELS[status] ?? status;
